import { Header } from "./Header.";
import Footer from "./Footer";
import "./Styles/ProductPage.css";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import separ from "../Images/Icones/separ.svg";
import trait from "../Images/Icones/trait.svg";
import IconButton from "@mui/material/IconButton";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { Add } from "@mui/icons-material";
import RemoveIcon from "@mui/icons-material/Remove";
import ProductDetail from "./ProductDetail";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-flip";

import Zoom from "react-img-hover-zoom";
import { EffectFlip, Navigation, Autoplay } from "swiper";
import { useState } from "react";
import { priceFr } from "../Services/Numbers";
import { TextField } from "@mui/material";
import {
  isProductInCart,
  getCart,
  setCart,
  addProductInCart,
  addProductInFavourites,
  getFavourites,
  isProductInFavourites,
} from "../Services/localStorage";
import Cookies from "universal-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const ProductPage = () => {
  const load = true;
  const params = useParams();
  const [product, setProduct] = useState({});
  const [qtyValue, setQtyValue] = useState(1);
  const [inFav, setInFav] = useState(false);
  const [inCart, setInCart] = useState(false);

  const productsURL = process.env.REACT_APP_API_BASE_URL + "/images/products/";
  const cookies = new Cookies();

  

  useEffect(() => {
    let slug = params.productSlug;

    axios
      .get(process.env.REACT_APP_API_BASE_URL + "/api/products?slug=" + slug, {
        headers: {
          "x-api-token": process.env.REACT_APP_API_TOKEN,
        },
      })
      .then((a) => {
        setProduct(a.data[0]);
        setInFav(isProductInFavourites(a.data[0].id));
        setInCart(isProductInCart(a.data[0].id));
      })
      .catch((error) => {
        console.log(error);
      });
  }, [load]);

  const addToFav = () => {
    addProductInFavourites(product);
    setInFav(isProductInFavourites(product.id));
  };

  const addToCart = () => {
    addProductInCart(product, qtyValue);
    setInCart(isProductInCart(product.id));
    toast.success(product.name + " a bien été ajouté à votre panier.");
  };

  let prices = "";

  if (product.discount) {
    let oldPrice = product.price;
    let newPrice = oldPrice - Math.round((oldPrice * product.discount) / 100);
    prices = (
      <>
        <p className="product-price">
          {priceFr(newPrice)} F
          <span className="product-old-price">{priceFr(oldPrice)} F</span>{" "}
        </p>
      </>
    );
  } else {
    prices = (
      <>
        <p className="product-price">{priceFr(product.price)} F </p>
      </>
    );
  }

  let stars = [];

  for (let i = 0; i < product.stars; i++) {
    stars.push(
      <StarIcon
        key={"full-star_" + product.slug + "_" + (i + 1)}
        sx={{ color: "#C8437E", fontSize: "20px" }}
      />
    );
  }

  if (product.stars < 5) {
    for (let i = 0; i < 5 - product.stars; i++) {
      stars.push(
        <StarOutlineIcon
          key={"empty-star_" + product.slug + "_" + (i + 1)}
          sx={{ color: "#C8437E", fontSize: "20px" }}
        />
      );
    }
  }
  const increaseQty = () => {
    setQtyValue(parseInt(document.getElementById("qty-input").value) + 1);
  };

  const decreaseQty = () => {
    setQtyValue(
      document.getElementById("qty-input").value == 1
        ? document.getElementById("qty-input").value
        : parseInt(document.getElementById("qty-input").value) - 1
    );
  };

  if (product.name) {
    document.title = product.name + " - KabaaShop";
  }
   const [backgroundPosition, setBackgroundPosition] = useState('-1000% -1000%');
   const [opacityFigure, setOpacity] = useState(1);
   const [delay, setDelay] = useState(2500);
  const outMouse =() => {
    setBackgroundPosition(`${-1000}% ${-1000}%`);
    setDelay(2500);
  }
  const onMouse =() => {
    // setDelay(500000);
    setOpacity(1);
  }
  const handleMouseMove = e => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = (e.pageX - left) / width * 100;
    const y = (e.pageY - top) / height * 100;
    setBackgroundPosition(`${x}% ${y}%`);
  }; 
  return (
    <>
      <ToastContainer />
      <Header />
      <div className="product-box">
        <div className="product">
          <div className="product-img">
            <div className="product-slider">
              <Swiper
                modules={[Navigation, Autoplay, EffectFlip]}
                slidesPerView={1}
                navigation
                autoplay={{
                 pauseOnMouseEnter:true,
                  delay: delay,
                  disableOnInteraction: false,
                }}
                loop={true}
                effect="flip"
              >
                 <SwiperSlide>
                  <figure
                  className="image-slider"
                    style={{
                      backgroundImage: `url(${productsURL + product.thumb})`,
                      backgroundPosition,
                      opacity:opacityFigure
                    }}
                    onMouseEnter={onMouse}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={outMouse}
                  >
                    <img
                    className="image-slider"
                    src={productsURL + product.thumb}
                  />
                   
                  </figure>
                </SwiperSlide>
                
                {product.images
                  ? product.images.map((img, index) => {
                      return (
                        <SwiperSlide key={index}>
                  <figure
                  className="image-slider"
                    style={{
                      backgroundImage: `url(${productsURL + img})`,
                      backgroundPosition,
                      opacity:opacityFigure
                    }}
                    onMouseEnter={onMouse}
                    onMouseMove={handleMouseMove}
                    onMouseLeave={outMouse}
                  >
                    <img
                    className="image-slider"
                    src={productsURL + img}
                  />
                   
                  </figure>
                </SwiperSlide>
                        // <SwiperSlide>
                        //   <img
                        //     className="image-slider"
                        //     src={productsURL + img}
                        //   />
                        // </SwiperSlide>
                      );
                    })
                  : ""}
              </Swiper>
             
            </div>
            {/*<p className='product-share'>Partagez le produit
                            <span>
                                <a href='#'><img src={facebook} alt="facebook" className='facebook' /> </a>
                                <img src={separ} alt="separ" className='social-sep' />
                                <a href='#'> <img src={whatsapp} alt="instagram" className='whatsapp' /> </a>
                            </span>
                        </p>*/}
          </div>
          <div className="product-detail">
            <div className="product-name">
              <p>{product.name}</p>
              <span className="product-favorite">
                {cookies.get("user") ? (
                  inFav ? (
                    <FavoriteIcon sx={{ fontSize: "30px", color: "#80377D" }} />
                  ) : (
                    <IconButton
                      onClick={() => {
                        addToFav();
                      }}
                      sx={{ padding: "3px", backgroundColor: "#ededff" }}
                      aria-label="add to favorites"
                    >
                      <FavoriteIcon
                        sx={{
                          fontSize: 15,
                          borderStyle: "solid",
                          borderRadius: "50%",
                          borderWidth: "6px",
                          borderColor: "#EDEDFF",
                        }}
                      />
                    </IconButton>
                  )
                ) : (
                  ""
                )}
              </span>
            </div>
            <div className="product-stars">
              <div className="stars">
                {stars}
                <img
                  src={separ}
                  alt="separ"
                  className="product-separator"
                />{" "}
                <span className="product-avis">
                  {product.comments ? product.comments.length : 0} avis
                </span>
              </div>

              <img src={trait} alt="trait" />
              {prices}

              <img src={trait} alt="trait" />

              <p className="product-number">
                <span
                  style={{
                    marginLeft: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    onClick={() => {
                      decreaseQty();
                    }}
                  >
                    <RemoveIcon />
                  </IconButton>
                  <TextField
                    readOnly
                    value={qtyValue}
                    sx={{ width: "70px" }}
                    id="qty-input"
                    variant="outlined"
                  />
                  <IconButton
                    onClick={() => {
                      increaseQty();
                    }}
                  >
                    <Add />
                  </IconButton>
                </span>
              </p>
              <img src={trait} alt="trait" />

              <div className="product-buttons">
                {inCart ? (
                  <>
                    <div className="product-button1">
                      <button onClick={goToCart}>Passer à l'achat</button>
                    </div>

                    <div className="alreadyInCart">
                      <span>Déjà dans le panier</span>
                    </div>
                  </>
                ) : (
                  <div className="product-button2">
                    <button
                      onClick={() => {
                        addToCart();
                      }}
                    >
                      Ajouter au panier
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div>
          <img src={trait} alt="trait" className="product-page-separator2" />
        </div>
        <ProductDetail
          productId={product.id}
          productSlug={product.slug}
          comments={product.comments ? product.comments : []}
          description={product.description ? product.description : ""}
        />
      </div>

      <Footer />
    </>
  );
};
function goToCart() {
  window.location.href = "/panier";
}
